var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-btn',{staticClass:"ml-2",attrs:{"min-width":"0","color":"third","exact":"","depressed":""}},[_vm._v(" Publish ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }